import { patchMutation } from '@/lib/react-query/mutate';
import { METIS_TASK_NAME, useMetisTriggerReplication } from '@/services/unifiedapi/replication';
import { notificationsKeys } from './keys';
import { MercuryTrackersIds } from '@/constants/mercuryPages';
import { useQueryActions } from '@/hooks/useQueryActions';

type MarkAllAsReadPayload = {
  read_all_at: string;
};

export const useNotificationsMarkAllAsReadMutation = () => {
  const { mutate: replicate } = useMetisTriggerReplication(METIS_TASK_NAME.ISSUE);
  const { invalidateQueries } = useQueryActions();

  return patchMutation<void, MarkAllAsReadPayload>({
    endpoint: 'v0/users/self/settings',
    mutationOptions: {
      onSuccess: () => {
        replicate('', {
          onSuccess: () => {
            invalidateQueries([
              notificationsKeys.notificationUnread(MercuryTrackersIds.finished),
              notificationsKeys.notificationUnread(MercuryTrackersIds.raw),
              notificationsKeys.notificationUnread(MercuryTrackersIds.vulnerabilities),
            ]);
          },
        });
      },
    },
  });
};
